import React from 'react';
import { Sparkles, Truck, RotateCcw } from 'lucide-react';

export const Banner: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-green-700 via-emerald-600 to-green-800 text-white text-xs sm:text-sm py-2.5 px-4 shadow-sm">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-center">
        <div className="flex items-center gap-1.5 font-medium">
          <Truck className="w-4 h-4 text-emerald-200" />
          <span>จัดส่งฟรีทั่วประเทศ เมื่อสั่งซื้อครบ <strong>800.-</strong> ขึ้นไป</span>
        </div>
        <span className="hidden sm:inline text-emerald-300/60">•</span>
        <div className="flex items-center gap-1.5 text-emerald-100">
          <RotateCcw className="w-3.5 h-3.5 text-emerald-300" />
          <span>ใส่ไม่พอดี ยื่นเปลี่ยนไซส์ได้ภายใน 7 วัน</span>
        </div>
        <span className="hidden sm:inline text-emerald-300/60">•</span>
        <div className="flex items-center gap-1.5 text-emerald-100">
          <Sparkles className="w-3.5 h-3.5 text-amber-300" />
          <span>ผ้า Premium Cotton 100% อยู่ทรง ไม่ย้วย</span>
        </div>
      </div>
    </div>
  );
};
